const taskTypes = {
  FACEBOOK_CHECKIN: {
    type: 'FACEBOOK_CHECKIN',
    icon: 'https://storage.googleapis.com/localfluence-library-production/proof-types/facebook-checkin.svg',
    verb: 'Checkin',
    company: 'Facebook',
    title: 'Facebook Checkin',
    action: 'Share Checkin',
    urlSlug: 'facebookCheckin',
    route: '/proof/facebookCheckin',
    examples: ['https://storage.googleapis.com/localfluence-library-production/socialPostExamples/postExample-1614821495.png'],
    helpText: {
      socialMention: true,
      socialTags: true,
    },
  },
  FACEBOOK_POST: {
    type: 'FACEBOOK_POST',
    icon: 'https://storage.googleapis.com/localfluence-library-production/proof-types/facebook.svg',
    verb: 'Post',
    company: 'Facebook',
    title: 'Facebook Post',
    action: 'Share Post',
    urlSlug: 'facebookPost',
    route: '/proof/facebookPost',
    examples: ['https://storage.googleapis.com/localfluence-library-production/socialPostExamples/postExample-1614821495.png'],
    helpText: {
      socialMention: true,
      socialTags: true,
    },
  },
  INSTAGRAM_POST: {
    type: 'INSTAGRAM_POST',
    icon: 'https://storage.googleapis.com/localfluence-library-production/proof-types/instagram.svg',
    verb: 'Post',
    company: 'Instagram',
    title: 'Instagram Post or Story',
    action: 'Upload Screenshot',
    urlSlug: 'instagramPost',
    route: '/proof/instagramPost',
    examples: [
      'https://storage.googleapis.com/localfluence-library-production/socialPostExamples/igPostExample-04262021.png',
      'https://storage.googleapis.com/localfluence-library-production/socialPostExamples/igStoryExample-04262021.jpg',
    ],
    helpText: {
      socialMention: true,
      socialTags: true,
    },
  },
  ONLINE_REVIEW: {
    type: 'ONLINE_REVIEW',
    icon: 'https://storage.googleapis.com/localfluence-library-production/proof-types/google.svg',
    verb: 'Review',
    company: 'Google',
    title: 'Google Review',
    action: 'Upload Screenshot',
    urlSlug: 'onlineReview',
    route: '/proof/onlineReview',
    examples: ['https://storage.googleapis.com/localfluence-library-production/socialPostExamples/onlineReviewExample-1614821495.png'],
    helpText: {
      socialMention: false,
      socialTags: false,
      reviewUrl: 'google_address',
    },
  },
  TIK_TOK: {
    type: 'TIK_TOK',
    icon: 'https://storage.googleapis.com/localfluence-library-production/proof-types/tik-tok.svg',
    verb: 'Video',
    company: 'TikTok',
    title: 'TikTok Video',
    action: 'Upload Video',
    urlSlug: 'TikTokPost',
    route: '/proof/TikTokPost',
    examples: [
      'https://storage.googleapis.com/localfluence-library-production/socialPostExamples/GOAT_TikTok_example.jpg',
      'https://storage.googleapis.com/localfluence-library-production/socialPostExamples/PWAT_TikTok_Example.PNG',
      'https://storage.googleapis.com/localfluence-library-production/socialPostExamples/Swig_TikTok_example.jpg',
    ],
    helpText: {
      socialMention: false,
      socialTags: true,
    },
  },
  FACEBOOK_REVIEW: {
    type: 'FACEBOOK_REVIEW',
    icon: 'https://storage.googleapis.com/localfluence-library-production/proof-types/facebook-review.svg',
    verb: 'Review',
    company: 'Facebook',
    title: 'Facebook Review',
    action: 'Upload Screenshot',
    urlSlug: 'FacebookReview',
    route: '/proof/facebookReview',
    examples: [
      'https://storage.googleapis.com/localfluence-library-production/socialPostExamples/fb_review_example_1.png',
      'https://storage.googleapis.com/localfluence-library-production/socialPostExamples/fb_review_example_2.png',
      'https://storage.googleapis.com/localfluence-library-production/socialPostExamples/fb_review_example_3.png',
    ],
    helpText: {
      socialMention: false,
      socialTags: false,
      reviewUrl: 'fb_business',
    },
  },
}

export function findByTitle(title: string) {
  return Object.values(taskTypes).find((taskType) => taskType.title === title)
}

export function findByUrlSlug(slug: string) {
  return Object.values(taskTypes).find((taskType) => taskType.urlSlug === slug)
}

export default Object.freeze(taskTypes)
